import { render } from "./ProjectItem.vue?vue&type=template&id=da812148&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=da812148&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da812148"

export default script